import uuid from "uuid/v1";
import { store } from "./get-redux-store";
import * as types from "../actions/types";

const trackingInfo = {
  "app-version": "28.1",
  "device-platform-version": "",
  "device-platform": "website",
  "device-type": "",
  "app-build-number": ""
};

const getDeviceId = () => {
  if (store.getState().storage.deviceId === undefined) {
    const deviceId = uuid();
    store.dispatch({
      type: types.SET_ITEM,
      payload: {
        key: "deviceId",
        value: deviceId
      }
    });

    return deviceId;
  }

  return store.getState().storage.deviceId;
};

export const getAppVersion = () => {
  return trackingInfo["app-version"];
};

export default {
  ...trackingInfo,
  "device-id": getDeviceId()
};
